<template>
  <div class="big-box">
    <div class="scroll-box">
      <div
        class="big-box-img"
        :style="{
          'background-image': `url(${bgUrl})`,
        }"
      >
        <div class="big-body">
          <img :src="tapTopUrl" alt="" class="tap-top" />
          <div class="theme" :style="{ color: customerPaperwork.titleColor }">
            {{ customerPaperwork.title }}
          </div>
          <div class="desc" :style="{ color: customerPaperwork.titleColor }">
            {{ customerPaperwork.desc }}
          </div>
          <div class="content-box">
            <div class="goods-box flexc">
              <img
                v-if="specifytList[0].logo"
                :src="specifytList[0].logo"
                alt=""
                class="goods-img"
              />
              <div v-else class="no-goods-img"></div>
              <div class="goods-info">
                <div class="goods-name" v-if="specifytList[0].skuName">
                  {{ specifytList[0].skuName }}
                </div>
                <div class="goods-price" v-if="specifytList[0].jdPrice">
                  京东价￥{{ specifytList[0].jdPrice }}
                </div>
                <div class="goods-exclusive" v-if="specifytList[0].jdPrice">
                  专属价￥<span class="exclusive-price">{{
                    prizeList[0].price
                  }}</span>
                </div>
                <div class="btn-box">
                  <div
                    class="btn-bg"
                    :style="{
                      'background-image': `url(${productModuleBtnUrl})`,
                      color: customerPaperwork.productModuleBtnColor,
                    }"
                  >
                    领取专属价
                  </div>
                </div>
              </div>
            </div>
            <div class="bargain-box">
              <div class="bargain-title">
                <img
                  class="bargain-icon"
                  src="https://cdn-image.yucrm.cn/e66318714ef74d119bafe08403c43ca5.png"
                  alt=""
                />
                <div class="bargain-price-box">
                  <span v-if="bargainConfig.bargainType == 0">已成功砍价</span>
                  <span v-else>已成功邀请</span>
                  <span
                    class="bargain-price"
                    :style="{
                      color: customerPaperwork.variableColor,
                    }"
                    >{{
                      bargainConfig.bargainType == 0
                        ? prizeList[0].reducePrice
                        : prizeList[0].successInviteNum
                    }}</span
                  >
                  <span v-if="bargainConfig.bargainType == 0">元</span>
                  <span v-else>人</span>
                </div>
                <img
                  class="bargain-icon"
                  src="https://cdn-image.yucrm.cn/e66318714ef74d119bafe08403c43ca5.png"
                  alt=""
                />
              </div>
              <div class="mt6 bargain-tip">
                已有24人完成砍价，抓紧邀请好友砍一刀吧
              </div>
              <div
                class="progress-bg"
                :style="{
                  'margin-top':
                    bargainConfig.bargainType == 0 ? '41px' : '95px',
                }"
              >
                <template v-if="bargainConfig.bargainType == 0">
                  <div
                    class="progress-bg-box"
                    :style="{
                      left: `${(index + 1) * (100 / prizeList.length) - 7}%`,
                    }"
                    v-for="(item, index) in prizeList"
                  >
                    <img
                      class="progress-bg-box-icon"
                      :src="amountStageUrl"
                      alt=""
                    />
                  </div>
                  <div
                    class="progress-bg-box2"
                    :style="{
                      left: `${
                        (index + 1) * (100 / prizeList.length) -
                        (prizeList.length <= 2
                          ? prizeList.length == 2
                            ? index == 0
                              ? 14
                              : 18
                            : 20
                          : index != 2
                          ? 14
                          : 18)
                      }%`,
                    }"
                    v-for="(item, index) in prizeList"
                  >
                    <div class="progress-bg-box2-info">
                      <div
                        :style="{
                          color: customerPaperwork.variableColor,
                        }"
                        class="progress-bg-box2-text"
                      >
                        砍价{{ item.reducePrice }}元
                      </div>
                      <div class="progress-bg-box2-num">剩余10名额</div>
                    </div>
                  </div>
                </template>
                <template v-else>
                  <div
                    class="progress-bg-box5"
                    :style="{
                      left: `${
                        (index + 1) * (100 / prizeList.length) -
                        (prizeList.length == 3
                          ? index == 0
                            ? 30
                            : 24
                          : prizeList.length == 2
                          ? 35
                          : 27)
                      }%`,
                    }"
                    v-for="(item, index) in prizeList"
                  >
                    <div class="invite-box">
                      <img :src="inviteStageUrl" alt="" />
                      <div class="invite-box-info">
                        <div
                          class="invite-box-info-text"
                          :style="{ color: customerPaperwork.stageColor }"
                        >
                          优惠
                        </div>
                        <div
                          class="invite-box-info-price"
                          :style="{ color: customerPaperwork.stageColor }"
                          v-if="item.reducePrice"
                        >
                          ￥<span class="invite-box-info-price-num">{{
                            item.reducePrice
                          }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="progress-bg-box3"
                    :style="{
                      left: `${
                        (index + 1) * (100 / prizeList.length) -
                        (prizeList.length == 3
                          ? index == 0
                            ? 22
                            : 16
                          : prizeList.length == 2
                          ? 28
                          : 20)
                      }%`,
                    }"
                    v-for="(item, index) in prizeList"
                  >
                    <img
                      class="progress-bg-box3-icon"
                      :key="index"
                      src="https://cdn-image.yucrm.cn/fedabd95564f4837972740bc18691e73.png"
                      alt=""
                    />
                  </div>
                  <div
                    class="progress-bg-box4"
                    :style="{
                      left: `${
                        (index + 1) * (100 / prizeList.length) -
                        (prizeList.length == 3
                          ? index == 0
                            ? 30
                            : 24
                          : prizeList.length == 2
                          ? 35
                          : 27)
                      }%`,
                    }"
                    v-for="(item, index) in prizeList"
                  >
                    <div class="progress-bg-box4-info">
                      <div
                        :style="{
                          color: customerPaperwork.variableColor,
                        }"
                        class="progress-bg-box4-text"
                      >
                        邀请{{ item.successInviteNum }}人
                      </div>
                      <div class="progress-bg-box4-num">剩余10名额</div>
                    </div>
                  </div>
                </template>
                <div
                  class="progress-bg-active"
                  :style="{
                    background: `linear-gradient(90deg, ${customerPaperwork.progressLeftColor} 0%, ${customerPaperwork.progressRightColor} 100%)`,
                    width: `${100 / prizeList.length}%`,
                  }"
                ></div>
              </div>
              <div
                class="bargain-box-btn"
                :style="{
                  'background-image': `url(${mainBtnUrl})`,
                  color: customerPaperwork.mainBtnColor,
                }"
              >
                <span class="bargain-btn-text">邀请好友砍价</span>
                <img
                  class="bargain-btn-icon"
                  src="https://cdn-image.yucrm.cn/921f6b588c3d4cfc9ce90ac6de8fe9c5.png"
                  alt=""
                />
              </div>
              <div
                class="bargain-box-time"
                :style="{
                  color: customerPaperwork.variableColor,
                }"
              >
                <span>活动距结束</span>
                <span class="bargain-box-time-num">30</span>
                <span>天</span>
                <span class="bargain-box-time-num">12</span>
                <span>:</span>
                <span class="bargain-box-time-num">12</span>
                <span>:</span>
                <span class="bargain-box-time-num">12</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="title" v-if="!oneShow">图为预览效果，以实际投效果为准</div>
  </div>
</template>
<script>
export default {
  name: "",
  components: {},
  mixins: [],
  props: {
    oneShow: {
      type: Boolean,
      default: false,
    },
    backgroundImage: {
      type: String,
      default: "",
    },
    customerPaperwork: {
      type: Object,
      default: () => ({}),
    },
    templateObj: {
      type: Object,
      default: () => ({}),
    },
    specifytList: {
      type: Array,
      default: () => [],
    },
    prizeList: {
      type: Array,
      default: () => [],
    },
    bargainConfig: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      couponLogo: "https://cdn-image.yucrm.cn/images/V24/popup_coupon.png",
      tapTopUrl:
        "https://cdn-image.yucrm.cn/images/dyAssets/images/preview/shop_top.png",
    };
  },
  computed: {
    bgUrl() {
      return this.backgroundImage
        ? JSON.parse(this.backgroundImage).activityBgImg
        : this.templateObj.url;
    },
    productModuleBtnUrl() {
      return this.customerPaperwork.productModuleBtnUrl
        ? this.customerPaperwork.productModuleBtnUrl
        : this.templateObj.url3;
    },
    amountStageUrl() {
      return this.customerPaperwork.amountStageUrl
        ? this.customerPaperwork.amountStageUrl
        : this.templateObj.url4;
    },
    inviteStageUrl() {
      return this.customerPaperwork.inviteStageUrl
        ? this.customerPaperwork.inviteStageUrl
        : this.templateObj.url5;
    },
    mainBtnUrl() {
      return this.customerPaperwork.mainBtnUrl
        ? this.customerPaperwork.mainBtnUrl
        : this.templateObj.url2;
    },
  },
  watch: {},
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.big-box {
  position: relative;
  width: 300px;
  height: 580px;
  box-shadow: 0px 4px 20px 0px rgba(18, 10, 60, 0.15);
  border-radius: 24px;
  border: 1px solid #ffffff;
  padding: 8px;
  margin-left: 231px;
  z-index: 1;
  background-color: #ffffff;

  .scroll-box {
    // width: 100%;
    width: 284px;
    overflow: hidden;
    height: 560px;
    scrollbar-width: none;
    &::-webkit-scrollbar {
      width: 0 !important;
    }
    -ms-overflow-style: none;
    border-radius: 24px;
  }

  .big-box-img {
    border-radius: 24px;
    width: 284px;
    height: 755px;
    background-repeat: no-repeat;
    background-size: 100%;
  }
  .big-body {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    .tap-top {
      margin-top: 8px;
    }
    .theme {
      width: 100%;
      margin-top: 14px;
      padding-left: 24px;
      font-weight: 600;
      font-weight: 600;
      font-size: 20px;
      color: #ffffff;
      line-height: 20px;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }
    .desc {
      width: 100%;
      margin-top: 10px;
      padding-left: 24px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 11px;
      color: #ffffff;
      line-height: 11px;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }
    .rank-record {
      margin-top: 32px;
      width: 85px;
      height: 20px;
      background: rgba(0, 0, 0, 0.15);
      border-radius: 19px 19px 19px 19px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 10px;
      color: #ffffff;
      line-height: 20px;
      text-align: center;
      font-style: normal;
      text-transform: none;
    }
    .content-box {
      margin-top: 18px;
      width: 100%;
      height: 100px;

      .goods-box {
        margin: 0 auto;
        width: 266px;
        height: 103px;
        background: #ffffff;
        padding: 12px;
        border-radius: 9px 9px 9px 9px;
        .goods-img {
          width: 79px;
          height: 79px;
          border-radius: 5px 5px 5px 5px;
        }
        .no-goods-img {
          width: 79px;
          height: 79px;
          border-radius: 5px 5px 5px 5px;
          border: 1px solid #cecece;
        }
        .goods-info {
          margin-left: 8px;
          .goods-name {
            width: 150px;
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 11px;
            color: #1a1a1a;
            line-height: 14px;
            text-align: left;
            font-style: normal;
            text-transform: none;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .goods-price {
            margin-top: 10px;
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 9px;
            color: #999999;
            line-height: 9px;
            text-align: left;
            font-style: normal;
            text-decoration-line: line-through;
            text-transform: none;
            text-decoration-line: line-through;
          }

          .goods-exclusive {
            margin-top: 10px;
            font-family: PingFang SC, PingFang SC;
            font-weight: 600;
            font-size: 8px;
            color: #f8304b;
            line-height: 8px;
            text-align: left;
            font-style: normal;
            text-transform: none;
            .exclusive-price {
              font-size: 13px;
            }
          }

          .btn-box {
            width: 100%;
            display: flex;
            justify-content: flex-end;
            text-align: right;
            .btn-bg {
              width: 61px;
              height: 22px;
              background-repeat: no-repeat;
              background-size: 100% 100%;
              font-family: PingFang SC, PingFang SC;
              font-weight: 400;
              font-size: 9px;
              line-height: 24px;
              text-align: center;
              font-style: normal;
              text-transform: none;
            }
          }
        }
      }

      .bargain-box {
        position: relative;
        margin: 9px auto;
        width: 266px;
        height: auto;
        // height: 249px;
        background: #ffffff;
        border-radius: 9px 9px 9px 9px;
        padding: 16px;
        border: 1px solid #ffffff;

        .bargain-title {
          display: flex;
          justify-content: center;
          align-items: center;

          .bargain-price-box {
            margin: 0 6px;
            font-family: PingFang SC, PingFang SC;
            font-weight: 600;
            font-size: 14px;
            color: #1a1a1a;
            line-height: 14px;
            text-align: left;
            font-style: normal;
            text-transform: none;
          }

          .bargain-icon {
            width: 10px;
            height: 10px;
          }
        }

        .bargain-tip {
          text-align: center;
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 9px;
          color: #999999;
          line-height: 9px;
          font-style: normal;
          text-transform: none;
        }

        .progress-bg {
          position: relative;
          margin-top: 41px;
          width: 236px;
          height: 7px;
          background: #ffe8e9;
          border-radius: 19px 19px 19px 19px;
          &-box {
            position: absolute;
            top: -6px;
            z-index: 1;
            &-icon {
              width: 21px;
              height: 21px;
            }
            &-text {
              font-family: PingFang SC, PingFang SC;
              font-weight: 500;
              font-size: 9px;
              line-height: 9px;
              text-align: center;
              font-style: normal;
              text-transform: none;
            }
            &-num {
              margin-top: 4px;
              font-family: PingFang SC, PingFang SC;
              font-weight: 400;
              font-size: 8px;
              color: #999999;
              line-height: 8px;
              text-align: center;
              font-style: normal;
              text-transform: none;
            }
            &-info {
              flex-shrink: 0;
              flex: unset;
              margin-top: 6px;
            }
          }
          &-box2 {
            margin-top: 12px;
            position: absolute;
            &-text {
              // white-space: nowrap;
              // overflow: hidden;
              // text-overflow: ellipsis;
              font-family: PingFang SC, PingFang SC;
              font-weight: 500;
              font-size: 9px;
              line-height: 9px;
              text-align: center;
              font-style: normal;
              text-transform: none;
            }
            &-num {
              // white-space: nowrap;
              // overflow: hidden;
              // text-overflow: ellipsis;
              margin-top: 4px;
              font-family: PingFang SC, PingFang SC;
              font-weight: 400;
              font-size: 8px;
              color: #999999;
              line-height: 8px;
              text-align: center;
              font-style: normal;
              text-transform: none;
            }
            &-info {
              width: 50px;
              margin-top: 8px;
            }
          }
          &-box3 {
            position: absolute;
            top: -3px;
            z-index: 1;
            &-icon {
              width: 11px;
              height: 11px;
            }
            &-text {
              font-family: PingFang SC, PingFang SC;
              font-weight: 500;
              font-size: 9px;
              line-height: 9px;
              text-align: center;
              font-style: normal;
              text-transform: none;
            }
            &-num {
              margin-top: 4px;
              font-family: PingFang SC, PingFang SC;
              font-weight: 400;
              font-size: 8px;
              color: #999999;
              line-height: 8px;
              text-align: center;
              font-style: normal;
              text-transform: none;
            }
            &-info {
              flex-shrink: 0;
              flex: unset;
              margin-top: 6px;
            }
          }
          &-box4 {
            margin-top: 12px;
            position: absolute;
            &-text {
              // white-space: nowrap;
              // overflow: hidden;
              // text-overflow: ellipsis;
              font-family: PingFang SC, PingFang SC;
              font-weight: 500;
              font-size: 9px;
              line-height: 9px;
              text-align: center;
              font-style: normal;
              text-transform: none;
            }
            &-num {
              // white-space: nowrap;
              // overflow: hidden;
              // text-overflow: ellipsis;
              margin-top: 4px;
              font-family: PingFang SC, PingFang SC;
              font-weight: 400;
              font-size: 8px;
              color: #999999;
              line-height: 8px;
              text-align: center;
              font-style: normal;
              text-transform: none;
            }
            &-info {
              width: 50px;
              margin-top: 8px;
            }
          }
          &-box5 {
            top: -55px;
            position: absolute;
            .invite-box {
              position: relative;
              img {
                width: 45px;
                height: 50px;
              }
              &-info {
                position: absolute;
                display: flex;
                flex-direction: column;
                align-items: center;
                top: 5px;
                left: 50%;
                transform: translate(-50%);
                &-text {
                  margin-bottom: 5px;
                  font-family: PingFang SC, PingFang SC;
                  font-weight: 400;
                  font-size: 8px;
                  line-height: 8px;
                  text-align: left;
                  font-style: normal;
                  text-transform: none;
                }
                &-price {
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;
                  font-family: PingFang SC, PingFang SC;
                  font-weight: 600;
                  font-size: 8px;
                  line-height: 8px;
                  text-align: center;
                  font-style: normal;
                  text-transform: none;
                  &-num {
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 600;
                    font-size: 12px;
                    text-align: center;
                    font-style: normal;
                    text-transform: none;
                  }
                }
              }
            }
          }
          &-active {
            position: absolute;
            top: 0;
            left: 0;
            height: 7px;
            border-radius: 19px 19px 19px 19px;
          }
        }

        &-btn {
          // position: absolute;
          position: relative;
          // left: 50%;
          margin-top: 70px;
          // bottom: 35px;
          // transform: translateX(-50%);
          width: 219px;
          height: 39px;
          background-repeat: no-repeat;
          background-size: 100% 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          .bargain-btn-text {
            font-family: PingFang SC, PingFang SC;
            font-weight: 600;
            font-size: 12px;
            line-height: 12px;
            text-align: left;
            font-style: normal;
            text-transform: none;
          }
          .bargain-btn-icon {
            width: 64px;
            height: 36px;
            position: absolute;
            left: 0;
            bottom: 0px;
            animation: identifier 2s infinite;
          }
          @keyframes identifier {
            0% {
              transform: translateX(0px);
            }
            100% {
              transform: translateX(170px);
            }
          }
        }

        &-time {
          margin-top: 20px;
          display: flex;
          justify-content: center;
          align-items: center;
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 8px;
          line-height: 8px;
          text-align: left;
          font-style: normal;
          text-transform: none;
          &-num {
            margin: 0 2px;
            display: inline-block;
            padding: 2px;
            background: rgba(246, 0, 6, 0.08);
            border-radius: 2px 2px 2px 2px;
          }
        }
      }
    }
  }
  .title {
    margin-top: 20px;
    font-size: 14px;
    font-weight: 400;
    line-height: 14px;
    text-align: center;
  }
  .ml4 {
    margin-left: 4px;
  }
  .ml6 {
    margin-left: 6px;
  }
  .mr6 {
    margin-right: 6px;
  }
  .mlr6 {
    margin: 0 6px;
  }
  .mb6 {
    margin-bottom: 6px;
  }
  .ml12 {
    margin-left: 12px;
  }
  .fvertical {
    display: flex;
    align-items: center;
  }
  .fcc {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .color-grey {
    display: inline-block;
    width: 1px;
    height: 7px;
    background-color: #cecece;
    // border: 0px solid #CECECE;
  }
}
</style>
